import { connect } from 'react-redux';
import SettingsContainer from './SettingsContainer';

const mapStateToProps = ({ auth, scoreCard }) => ({
    isAuthenticated: auth.isAuthenticated,
    isSignedIn: auth.isSignedIn,
    enabled: scoreCard.enabled,
    user: auth.user
});

export default connect(mapStateToProps)(SettingsContainer);
